import { createContext, useContext } from 'react';

export const PublicContent = createContext({ post: null });
export const usePublicContent = () => useContext(PublicContent);
